// Import Material UI
import { AppBar, Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, InputAdornment, Menu, MenuItem, OutlinedInput, Tab, Tabs, Tooltip, withStyles } from "@material-ui/core"
import { Close } from "@material-ui/icons"
import SearchIcon from "@material-ui/icons/Search";

// Import Packages
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { chromeDark, chromeLight, ObjectInspector } from "react-inspector";

// Import Pages
import LogsDetail from "./LogsDetail";
import Pagination from "../../../../components/Pagination/Pagination";
import FullScreen from "../../../../components/FullScreen/FullScreen";
import MidLogsDetail from "./MidLogsDetail";
import LogInfoDetails from "./LogInfoDetails";
import Search from "../../../../components/Search/Search";
import OldLogsDetail from "./OldLogsDetail";
import LogService from "../../../../services/LogService/LogService";

// Import Services
import QueueService from "../../../../services/QueueService/QueueService";

// Import Icons
import emptyPageIcon from '../../../../assets/icons/configurationIcons/empty-page.svg';
import leftIcon from "../../../../assets/icons/configurationIcons/pagination-left-icon.svg";
import rightIcon from "../../../../assets/icons/configurationIcons/pagination-right-icon.svg";
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import automEndIcon from '../../../../assets/icons/configurationIcons/autom-end-log-icon.svg';
import actionInfoIcon from '../../../../assets/icons/configurationIcons/monitoring-action-info-icon.svg';
import actionErrorIcon from '../../../../assets/icons/configurationIcons/monitoring-action-error-icon.svg';
import keySelectIcon from '../../../../assets/icons/configurationIcons/log-search-key-select-icon.svg';
import LogWebhookIcon from '../../../../assets/icons/configurationIcons/Log-webhook-icon.svg';
import LogWarningIcon from '../../../../assets/icons/configurationIcons/Log-warning-icon.svg';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';

// Import Recoil
import { useRecoilValue, useSetRecoilState } from "recoil";
import { alertState, baseOrigin, currentPageAtom, itemsPerPageAtom, personalizationState } from "../../../../recoil-store/recoil-state";

// Import CSS
import "./OperationLogs.css";
import { convertTimestampToDate, convertToDateFormat, formatNanosecondsDifference, getLocalItemsForPagination, setLocalItemsForPagination, showPreviewData } from "../../../../helpers/helper";

const CustomTabs = withStyles({
    root: {
        backgroundColor: 'white',
        borderRadius: 8,
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        minHeight: 32,
    },
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '&::after': {
            content: '""',
            width: '40%', // Çizginin genişliği (istediğiniz değeri buraya girin)
            height: 3, // Çizginin yüksekliği
            borderRadius: 3,
            backgroundColor: '#0B2949', // Çizginin rengi
        },
    },
})(Tabs);

const CustomTab = withStyles((theme) => ({
    root: {
        textTransform: 'uppercase',
        fontSize: "11px",
        minWidth: 100,
        minHeight: 33, // Sets the minimum height to 33px
        // height: 33, // Sets the height to 33px
        padding: "12px 20px",
        lineHeight: "normal",
        fontWeight: "800",
        // marginRight: theme.spacing(1),
        letterSpacing: "1px",
        color: '#BEBEBE',
        '&$selected': {
            color: '#4F6E90',
            fontWeight: "800",
        },
        '&:hover': {
            color: '#4F6E90',
            opacity: 1,
        },
    },
    selected: {}, // This is necessary for the `&$selected` rule to work
}))(Tab);

const StyledMenu = withStyles({
    paper: {
        backgroundColor: "#FCFCFC",
        border: '1px solid #E7E7E7',
        padding: "10px 10px 20px 10px",
        // marginTop: "10px",
        // marginLeft: "135px",
        display: "flex",
        justifyContent: "start",
        flexDirection: "column",
        borderRadius: "4px"
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const defaultLibraryImg = `default_library.png`

export const AllOperationLogs = ({ data, setOpenActivityLog, setSelectedOperation, ehLog, ehGroupId, summaryLog }) => {
    const { t } = useTranslation();
    const [logs, setLogs] = useState([])
    const [isNewLogs, setIsNewLogs] = useState(false)
    const [isMidLogs, setIsMidLogs] = useState(false)
    const [logsCount, setLogsCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('');
    const [tab, setTab] = useState("Root");
    const [breadCrumbTabs, setBreadCrumbTabs] = useState([]);
    const [otherTabs, setOtherTabs] = useState([]);
    const [searchOtherTabs, setSearchOtherTabs] = useState([]);
    const [tabWidthOverFlow, setTabWidthOverFlow] = useState(false);
    const [type, setType] = useState("input");
    const [fullScreenValue, setFullScreenValue] = useState({ type: "", value: "" });
    const [selectedGroupLog, setSelectedGroupLog] = useState({})
    const [selectedLog, setSelectedLog] = useState({});
    // const currentPage = useRecoilValue(currentPageAtom)
    // const itemsPerPage = useRecoilValue(itemsPerPageAtom)
    const [currentIndex, setCurrentIndex] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)
    const [outPage, setOutPage] = useState(0)
    const [outItemsPerPage, setOutItemsPerPage] = useState(null)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [findCount, setfindCount] = useState(0)
    const [searchedLogs, setSearchedLogs] = useState([])
    const [searchedLogIndex, setSearchedLogIndex] = useState(0)
    const [forceUpdate, setForceUpdate] = useState(false);
    const [findedPages, setFindedPages] = useState([])
    // const [highlightIndex, setHighlightIndex] = useState(0)
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [openEhLogs, setOpenEhLogs] = useState(false);
    const resultRefs = useRef([]);
    const [findedOpetaionGroupIds, setFindedOpetaionGroupIds] = useState([])
    const personalization = useRecoilValue(personalizationState);
    const [keySelectAnchorEl, setKeySelectAnchorEl] = useState(null);
    const [selectedFilters, setSelectedFilters] = useState([
        { name: "label", status: true, disabled: true },
        { name: "level", status: true, disabled: true },
        { name: "action_name", status: true, disabled: true },
        { name: "library_name", status: true, disabled: true },
        { name: "error", status: false, disabled: false },
        { name: "info", status: false, disabled: false },
        { name: "input", status: false, disabled: false },
        { name: "output", status: false, disabled: false },
    ]);
    const base_origin = useRecoilValue(baseOrigin);
    const setAlert = useSetRecoilState(alertState);
    const label = "MESSAGES.MONITORING."

    const customTheme = {
        ...chromeDark, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: 'transparent', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
    };

    const customInputOutputTheme = {
        ...chromeLight, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: '#F3F3F3', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
        // TREENODE_PADDING_LEFT: '20px',
        // ARROW_FONT_SIZE: '1.1em',
        // ARROW_MARGIN_RIGHT: '3px',
        // ARROW_ANIMATION_DURATION: '0.2s',
    };

    const handleClose = () => {
        setOpenActivityLog(false)
    }

    useEffect(() => {
        const localItemsPerPage = getLocalItemsForPagination("logs")
        if (summaryLog) {
            fetchDataForSummary()
            return
        }
        fetchData(0, localItemsPerPage ? localItemsPerPage : 10)
    }, [data]);
    useEffect(() => {
        setType("input")
    }, [selectedLog]);

    useEffect(() => {
        // Highlight edilen elemana kaydır
        if (resultRefs.current[highlightedIndex]) {
            resultRefs.current[highlightedIndex].scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        }
        if (resultRefs?.current[highlightedIndex]) {
            resultRefs.current[highlightedIndex].style.backgroundColor = "orange"
        }
    }, [highlightedIndex]);



    useEffect(() => {
        count = 0
        const elements = document.querySelectorAll(".all-logs-breadcrumb-item")
        let width = 0
        elements.forEach((element) => {
            width += element.offsetWidth
        })
        if (width) {
            const element = document.querySelector(".all-logs-breadcrumb-container")
            const maxWidth = element.offsetWidth
            if (width > maxWidth) {
                setTabWidthOverFlow(true)
            }
            else {
                setTabWidthOverFlow(false)
            }
        }
        // const interval = setInterval(() => {
        //     if (!tabWidthOverFlow) {
        //         const elements = document.querySelectorAll(".all-logs-breadcrumb-item")
        //         let width = 0
        //         elements.forEach((element) => {
        //             width += element.offsetWidth
        //         })
        //         if (width) {
        //             const element = document.querySelector(".all-logs-breadcrumb-container")
        //             const maxWidth = element.offsetWidth
        //             if (width > maxWidth) {
        //                 setTabWidthOverFlow(true)
        //             }
        //             else {
        //                 setTabWidthOverFlow(false)
        //             }
        //         }
        //         clearInterval(interval)
        //     }
        // }, 200);
    }, [tab]);

    useEffect(() => {
        if (resultRefs?.current.length) {
            resultRefs.current.forEach((ref) => {
                ref.style.backgroundColor = "yellow"
            })
        }
        if (resultRefs?.current[0]) {
            resultRefs.current[0].style.backgroundColor = "orange"
        }
        setHighlightedIndex(0)
        // setOutPage(0)
    }, [resultRefs.current.length]);
    useEffect(() => {
        if (searchedLogIndex && searchedLogs.length) {
            var startDate = new Date();
            var endDate = new Date();
            endDate.setDate(endDate.getDate() - 1); // Dünden başla
            endDate.setHours(startDate.getHours()); // Saati aynı yap
            const excludeEhFlow = ehLog ? false : true
            setLoading(true);
            let parent_id = searchedLogs[searchedLogIndex - 1]?.parent_id ? searchedLogs[searchedLogIndex - 1].parent_id : searchedLogs[searchedLogIndex - 1]?.group_id
            const pageNumber = searchedLogs[searchedLogIndex - 1].page_number
            if (searchedLogs[searchedLogIndex - 1].parent_id && searchedLogs[searchedLogIndex - 1].parent_id !== ehGroupId) {
                LogService.getLogsByGroupId(data.operation_id, parent_id)
                    .then((response) => {
                        if (response?.data) {
                            setSelectedGroupLog(response.data)
                            QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, (pageNumber - 1) * itemsPerPage, itemsPerPage, parent_id, "detail", excludeEhFlow)
                                .then((res) => {
                                    if (Array.isArray(res?.data)) {
                                        setLogs(res.data);
                                        setLogsCount(res.logs_count)
                                        setOutPage(pageNumber)
                                        if (searchedLogs[searchedLogIndex - 1].breadcrumb.length > 1) {
                                            let newBreadCrumb = JSON.parse(JSON.stringify(searchedLogs))
                                            newBreadCrumb = newBreadCrumb[searchedLogIndex - 1].breadcrumb
                                            newBreadCrumb.shift()
                                            setTabWidthOverFlow(false)
                                            setBreadCrumbTabs(newBreadCrumb)
                                            setTab(newBreadCrumb[newBreadCrumb.length - 1].id)
                                        }
                                        else {
                                            setBreadCrumbTabs([])
                                            setTab("Root")
                                        }
                                    } else {
                                        setLogs([]);
                                    }
                                    setCurrentIndex((0 / itemsPerPage) + 1)
                                    setLoading(false);
                                })
                                .catch(() => {
                                    setLoading(false);
                                });
                        } else {
                            setLoading(false);
                        }
                    })
            }
            else if (searchedLogs[searchedLogIndex - 1].group_id) {
                if (ehGroupId && searchedLogs[searchedLogIndex - 1]?.parent_id === ehGroupId) {
                    parent_id = searchedLogs[searchedLogIndex - 1].parent_id
                }
                else {
                    parent_id = ""
                }
                QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, (pageNumber - 1) * itemsPerPage, itemsPerPage, parent_id, "detail", excludeEhFlow)
                    .then((response) => {
                        if (Array.isArray(response?.data)) {
                            setLogs(response.data);
                            setLogsCount(response.logs_count)
                            setSelectedGroupLog({})
                            setOutPage(pageNumber)
                            if (searchedLogs[searchedLogIndex - 1].breadcrumb.length > 1) {
                                let newBreadCrumb = JSON.parse(JSON.stringify(searchedLogs))
                                newBreadCrumb = newBreadCrumb[searchedLogIndex - 1].breadcrumb
                                newBreadCrumb.shift()
                                setTabWidthOverFlow(false)
                                setBreadCrumbTabs(newBreadCrumb)
                                setTab(newBreadCrumb[newBreadCrumb.length - 1].id)
                            }
                            else {
                                setBreadCrumbTabs([])
                                setTab("Root")
                            }
                        } else {
                            setLogs([]);
                        }
                        setCurrentIndex(((pageNumber - 1) * itemsPerPage / itemsPerPage) + 1)
                        setLoading(false);
                    })
                    .catch(() => {
                        setLoading(false);
                        //err
                    });
            }
            else {
                setLoading(false);
            }
        }
    }, [searchedLogIndex, forceUpdate]);

    const fetchData = (startIndex, itemsPerPage, status, page) => {
        setLocalItemsForPagination("logs", itemsPerPage)
        // Şu anki tarih ve saat
        var startDate = new Date();

        // 24 saat önceki tarih ve saat
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Dünden başla
        endDate.setHours(startDate.getHours()); // Saati aynı yap

        let parentId
        let excludeEhFlow = true

        if (ehLog) {
            parentId = ehGroupId
            excludeEhFlow = false
        }

        setLoading(true);
        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, startIndex, itemsPerPage, parentId, "detail", excludeEhFlow)
            .then((response) => {
                if (Array.isArray(response?.data)) {
                    setLogs(response.data);
                    setLogsCount(response.logs_count)
                } else {
                    setLogs([]);
                }
                setIsMidLogs(response.hasGroupId)
                setIsNewLogs(response.new_design)
                setItemsPerPage(itemsPerPage)
                setCurrentIndex((startIndex / itemsPerPage) + 1)
                setCurrentPage(page ? page : 1)
                setOutItemsPerPage(itemsPerPage)
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                //err
            });
    }

    const fetchDataForSummary = async () => {
        var startDate = new Date();
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Dünden başla
        endDate.setHours(startDate.getHours()); // Saati aynı yap
        const excludeEhFlow = true
        setLoading(true);
        setIsNewLogs(true)
        let parent_id = summaryLog?.parentId
        let pageNumber = 1
        const localItemsPerPage = getLocalItemsForPagination("logs")
        const rps = await LogService.getSummaryLogBreadCrumb(data.operation_id, localItemsPerPage ? localItemsPerPage : 10, parent_id, summaryLog.groupId)
        if (rps.status) {
            if (rps.breadcrumb?.length > 1) {
                let newBreadCrumb = JSON.parse(JSON.stringify(rps.breadcrumb))
                newBreadCrumb.shift()
                setTabWidthOverFlow(false)
                setBreadCrumbTabs(newBreadCrumb)
                setTab(newBreadCrumb[newBreadCrumb.length - 1].id)
            }
            else {
                setBreadCrumbTabs([])
                setTab("Root")
            }
            pageNumber = rps.pageNumber
        }
        if (summaryLog?.type === "parent_id") {
            LogService.getLogsByGroupId(data.operation_id, parent_id)
                .then((response) => {
                    if (response?.data) {
                        setSelectedGroupLog(response.data)
                        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, (pageNumber - 1) * itemsPerPage, itemsPerPage, parent_id, "detail", excludeEhFlow)
                            .then((res) => {
                                if (Array.isArray(res?.data)) {
                                    setLogs(res.data);
                                    setLogsCount(res.logs_count)
                                    setOutPage(pageNumber)
                                } else {
                                    setLogs([]);
                                }
                                setCurrentIndex(((pageNumber - 1) * itemsPerPage / itemsPerPage) + 1)
                                setLoading(false);
                            })
                            .catch(() => {
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                })
        }
        else if (summaryLog?.type === "group_id") {
            parent_id = ""
            QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, (pageNumber - 1) * itemsPerPage, itemsPerPage, parent_id, "detail", excludeEhFlow)
                .then((response) => {
                    if (Array.isArray(response?.data)) {
                        setLogs(response.data);
                        setLogsCount(response.logs_count)
                        setSelectedGroupLog({})
                        setOutPage(pageNumber)
                    } else {
                        setLogs([]);
                    }
                    setCurrentIndex(((pageNumber - 1) * itemsPerPage / itemsPerPage) + 1)
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                    //err
                });
        }
        else {
            setLoading(false);
        }
    };

    const groupFetchData = useCallback((startIndex, itemsPerPage, status, page) => {
        setLocalItemsForPagination("logs", itemsPerPage)
        var startDate = new Date();
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1);
        endDate.setHours(startDate.getHours());
        setLoading(true);
        const parent_id = selectedGroupLog.group_id
        const excludeEhFlow = ehLog ? false : true
        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, startIndex, itemsPerPage, parent_id, "detail", excludeEhFlow)
            .then((response) => {
                if (Array.isArray(response?.data)) {
                    setLogs(response.data);
                    setLogsCount(response.logs_count)
                    setItemsPerPage(itemsPerPage)
                    setCurrentIndex((startIndex / itemsPerPage) + 1)
                    setOutItemsPerPage(itemsPerPage)
                } else {
                    setLogs([]);
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [selectedGroupLog])

    const handleMoveHighlight = (direction) => {
        if ((direction === "right" && searchedLogIndex + 1 > searchedLogs.length) || (direction === "left" && searchedLogIndex - 1 < 1)) {
            return
        }
        setOutPage(null)
        setSearchedLogIndex((pre) => {
            switch (direction) {
                case "right":
                    return pre + 1
                case "left":
                    return pre - 1
                case "first":
                    return 1
                case "last":
                    return searchedLogs.length
                default:
                    return pre
            }
        })
    }

    let count = 0

    const highlightText = (text, highlight, positionIndex) => {
        if (!highlight) return text;
        const parts = text.split(new RegExp(`(${highlight})`, "gi"));
        return parts.map((part, index) => {
            return part.toLowerCase() === highlight.toLowerCase() ? (
                <span
                    key={index}
                    ref={(el) => {
                        if (el && part.toLowerCase() === highlight.toLowerCase()) {
                            resultRefs.current[count] = el;
                            count = count + 1
                        }
                    }}
                    style={{
                        backgroundColor: "yellow",
                    }}
                >
                    {part}
                </span>
            ) : (
                part
            )
        }
        );
    };

    const handleSearch = async (event) => {
        if (searchLoading) {
            return
        }
        const activeNames = selectedFilters
            .filter(filter => filter.status === true)
            .map(filter => filter.name);

        console.log("activeNames: ", activeNames)

        const body = {
            per_page: itemsPerPage,
            operation_id: data.operation_id,
            search_text: event ? event.target.value : searchTerm,
            columns_to_search: JSON.stringify(activeNames), // Bu alan bir dizi olarak gönderiliyor
            exclude_eh_flow: !ehLog,
            parent_id: ehLog ? ehGroupId : ""
        };
        setSearchLoading(true)
        const response = await LogService.searchLog(body)
        setSearchLoading(false)
        if (response && response.status) {
            if (response.data) {
                setSearchedLogs(response.data)
                setSearchedLogIndex(1)
                setForceUpdate((pre) => !pre)
                if (response.data[0] && response.data[0]?.breadcrumb.length > 0) {
                    if (ehLog) {
                        response.data.forEach((data) => {
                            data.breadcrumb.splice(1, 1)
                        })
                    }
                    let newBreadCrumb = JSON.parse(JSON.stringify(response.data[0]))
                    newBreadCrumb = newBreadCrumb.breadcrumb
                    newBreadCrumb.shift()
                    setTabWidthOverFlow(false)
                    if (newBreadCrumb.length) {
                        setBreadCrumbTabs(newBreadCrumb)
                        setTab(newBreadCrumb[newBreadCrumb.length - 1].id)
                    }
                }
            }
            else {
                refreshDatas()
            }
            setfindCount(response.numberOfLogsFound)
        }
        else {
            refreshDatas()
            setfindCount(0)
        }
    };

    const refreshDatas = () => {
        setFindedOpetaionGroupIds([])
        setSearchedLogs([])
        setFindedPages([])
    }
    const handleChangeTab = (e, value) => {
        if (value === "..." || tab === value) {
            return
        }
        setTabWidthOverFlow(false)
        setTab(value)
    }
    const handleOpenOtherTabs = () => {
        const newTabs = breadCrumbTabs.slice(0, -3)
        setOtherTabs(newTabs)
        setSearchOtherTabs(newTabs)
    }
    const handleSelectTab = (item, index) => {
        if (item.id === tab) {
            return
        }
        else if (index === -1) {
            setBreadCrumbTabs([])
            fetchData(0, itemsPerPage)
            setSelectedGroupLog({})
            return
        }
        else {
            var startDate = new Date();
            var endDate = new Date();
            endDate.setDate(endDate.getDate() - 1); // Dünden başla
            endDate.setHours(startDate.getHours()); // Saati aynı yap
            const excludeEhFlow = ehLog ? false : true
            setLoading(true);
            const parent_id = item.id
            LogService.getLogsByGroupId(data.operation_id, parent_id)
                .then((response) => {
                    if (response?.data) {
                        setSelectedGroupLog(response.data)
                        QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, 0, itemsPerPage, parent_id, "detail", excludeEhFlow)
                            .then((response) => {
                                if (Array.isArray(response?.data)) {
                                    setLogs(response.data);
                                    setLogsCount(response.logs_count)
                                    setOutPage(1)
                                } else {
                                    setLogs([]);
                                }
                                setCurrentIndex((0 / itemsPerPage) + 1)
                                setLoading(false);
                            })
                            .catch(() => {
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                })
        }
        setBreadCrumbTabs((pre) => {
            const newTabs = pre.slice(0, index + 1)
            return newTabs
        })
    }

    const handleSelectGroupLog = (item, direction) => {
        var startDate = new Date();
        var endDate = new Date();
        endDate.setDate(endDate.getDate() - 1); // Dünden başla
        endDate.setHours(startDate.getHours()); // Saati aynı yap
        const excludeEhFlow = ehLog ? false : true
        setLoading(true);
        if (direction === "next") {
            setSelectedGroupLog(item)
            const parent_id = item.group_id
            QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, 0, itemsPerPage, parent_id, "detail", excludeEhFlow)
                .then((response) => {
                    setOutPage(null)
                    if (Array.isArray(response?.data)) {
                        setTabWidthOverFlow(false)
                        setLogs(response.data);
                        setLogsCount(response.logs_count)
                        setBreadCrumbTabs(pre => {
                            let newTabs = pre
                            newTabs.push({
                                name: item.library_label ? `${item.library_label?.includes('CUSTOM') ? item.library_name :
                                    t("CONTENT.LIBRARY." + item.library_name + ".NAME")}-${item.label
                                        ? item.label
                                        : item?.library_label?.includes('CUSTOM') ? item?.action_name
                                            : t("CONTENT.LIBRARY." + item.library_name + ".ACTION." + item.action_name)}` : item.info ? item.info : item.level,
                                id: item.group_id,
                                image: item.image,
                                is_system: item.is_system
                            })
                            return newTabs
                        })
                        setTab(item.group_id)
                    } else {
                        setLogs([]);
                    }
                    setOutPage(1)
                    setCurrentIndex((0 / itemsPerPage) + 1)
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
        else {
            // setSelectedGroupLog(item)
            if (breadCrumbTabs.length > 1) {
                const parent_id = breadCrumbTabs[breadCrumbTabs.length - 2].id
                LogService.getLogsByGroupId(data.operation_id, parent_id)
                    .then((response) => {
                        if (response?.data) {
                            setTabWidthOverFlow(false)
                            setSelectedGroupLog(response.data)
                            setTab(parent_id)
                            setBreadCrumbTabs(pre => {
                                let newTabs = pre
                                newTabs.pop()
                                return newTabs
                            })
                            QueueService.getQueueActivityLog(`?operation_id=${data.operation_id}`, endDate, startDate, 0, itemsPerPage, parent_id, "detail", excludeEhFlow)
                                .then((response) => {
                                    setOutPage(null)
                                    if (Array.isArray(response?.data)) {
                                        setLogs(response.data);
                                        setLogsCount(response.logs_count)
                                    } else {
                                        setLogs([]);
                                    }
                                    setOutPage(1)
                                    setCurrentIndex((0 / itemsPerPage) + 1)
                                    setLoading(false);
                                })
                                .catch(() => {
                                    setLoading(false);
                                });
                        } else {
                            setLoading(false);
                        }
                    })
            }
            else {
                fetchData(0, itemsPerPage)
                setTab("root")
                setSelectedGroupLog({})
                setBreadCrumbTabs([])
            }
        }
    }

    const handleOpenInfoArea = (item) => {
        setSelectedLog(item);
    };

    const handleCopyInputAndOutput = async (e, text) => {
        try {
            await navigator.clipboard.writeText(text);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + `COPIED`),
                severity: 'success'
            }));
            e.preventDefault()
            e.stopPropagation()
        } catch (err) {
        }
    };

    const findLogIcon = (tag) => {
        switch (tag) {
            case "INFO":
                return actionInfoIcon
            case "ERROR":
                return actionErrorIcon
            default:
                return actionInfoIcon
        }
    };

    const renderDataTable = (logOutput) => {
        if (!logOutput) {
            return undefined
        }

        let v = logOutput.value;
        if (!Array.isArray(logOutput.value) && logOutput.value[0]) {
            v = logOutput.value[0];
        }

        return v.slice(0, Math.min(5, v.length)).map((row, index) => {
            const backgroundColor = index === 0 ? '#4F6E90' : '#F4F4F4';
            const color = index === 0 ? '#F8F8F8' : '#4A4A4A';

            return (
                <tr key={index} style={{ backgroundColor, color }}>
                    {row.slice(0, Math.min(2, row.length)).map((cell, cellIndex) => {
                        return <td className={index === 0 ? "data-table-first-header-td" : ""} key={cellIndex}>{cell}</td>;
                    })}
                </tr>
            );
        });
    };

    const handleOpenKeySelect = (event) => {
        setKeySelectAnchorEl(event.currentTarget);
    };

    const handleCloseKeySelect = () => {
        setKeySelectAnchorEl(null);
    };

    const handleKeySelectChange = (event, index) => {
        setSelectedFilters((pre) => {
            let newFilters = JSON.parse(JSON.stringify(pre))
            newFilters[index].status = !newFilters[index].status;
            return newFilters
        });
    };

    return (
        <Dialog
            id={ehLog ? "all-operation-eh-log-dialog" : "all-operation-log-dialog"}
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            // onClose={handleClose}
            PaperProps={{
                style: {
                    // minWidth: "95%",
                    maxWidth: "95%",
                    width: selectedLog.level && isNewLogs ? "80%" : "50%",
                    // height: "90%",
                    height: "100%",
                    borderRadius: " 4px",
                    // padding: "4px 22px",
                    padding: "0",
                    background: "transparent",
                    flexDirection: "row",
                    gap: "20px",
                    overflow: "hidden"
                },
            }}
        >
            <div className="all-operation-log-side-container" style={{ width: selectedLog.level && isNewLogs ? "60%" : "100%", padding: selectedLog.level && isNewLogs ? "0" : "4px 22px" }}>
                <DialogTitle id="alert-dialog-title">
                    <div id="about-title" className="add-group-header all-logs-header">
                        <div>
                            <h4 className="autom-name-title">{t(label + (ehLog ? "ERROR-HANDLING-FLOW-LOGS" : "ALL-LOGS"))}</h4>
                            <small
                                className="conf-field-desc"><em>{t(label + (ehLog ? "ERROR-HANDLING-FLOW-LOGS-DESCRIPTION" : "ALL-LOGS-DESCRIPTION"))}</em></small>
                        </div>
                        <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                    </div>
                </DialogTitle>
                {/* <DialogContent className="all-logs-header-tab-container">
                <Box sx={{ width: 'fit-content' }}>
                    <CustomTabs value={tab} onChange={handleChangeTab}
                        textColor="primary">
                        <CustomTab value={"summary"} label={t(label + "SUMMARY")} />
                        <CustomTab value={"detail"} label={t(label + "DETAILED-LOGS")} />

                    </CustomTabs>
                </Box>
            </DialogContent> */}
                <DialogContent className="all-logs-search-container">
                    {isNewLogs || isMidLogs ? <div className="all-logs-filter-and-search-container">
                        <Grid container spacing={12} style={{ marginTop: 2 }}>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <OutlinedInput
                                    id="outlined-adornment-amount"
                                    className="monitoring-searchbar-input"
                                    // value={value}
                                    autoFocus={true}
                                    onFocus={(event) => {
                                        event.target.setAttribute('autocomplete', 'off');
                                    }}
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(event) => {
                                        setSearchTerm(event.target.value)
                                        // handleSearch(event)
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter') {  // Enter tuşuna basıldığında
                                            handleSearch(event);  // handleSearch fonksiyonunu çağır
                                        }
                                    }}
                                    // onChange={(event) => handleSearch(event)}
                                    startAdornment={<InputAdornment position="start"><SearchIcon
                                        className="searchbar-icon" /></InputAdornment>}

                                />
                                {/* <img src={keySelectIcon} className="all-logs-search-key-select-icon" onClick={handleOpenKeySelect} /> */}
                                <div className="all-logs-search-key-select-menu-container">
                                    <Button className="all-logs-search-key-select-button">
                                        <img src={keySelectIcon} onClick={handleOpenKeySelect} />
                                    </Button>
                                    <StyledMenu
                                        anchorEl={keySelectAnchorEl}
                                        open={Boolean(keySelectAnchorEl)}
                                        onClose={handleCloseKeySelect}
                                    >
                                        {selectedFilters && selectedFilters.length ? selectedFilters.map((filter, index) => {
                                            const name = filter.name.split('_') // '_' karakterine göre böl
                                                .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Her kelimenin ilk harfini büyüt
                                                .join(' '); // Bölünen kelimeleri tekrar birleştir, araya boşluk koy
                                            return <MenuItem className="all-logs-search-key-menu-item" disabled={filter.disabled}
                                                onClick={(e) => handleKeySelectChange(e, index)}>
                                                <FormControlLabel
                                                    disabled={true}
                                                    style={{ cursor: "pointer" }}
                                                    control={
                                                        <Checkbox
                                                            checked={filter.status}
                                                            name={filter.name}
                                                        />
                                                    }
                                                    label={name}
                                                />
                                            </MenuItem>
                                        })
                                            : ""}
                                    </StyledMenu>
                                </div>
                            </Grid>
                        </Grid>
                        {isNewLogs ? <Button className="all-logs-filter-button" onClick={() => handleSearch()} disabled={searchLoading || !searchTerm}>
                            {searchLoading ? <CircularProgress size={18} /> : t(label + "SEARCH")}
                        </Button> : ""}
                    </div> : ""}

                    {isNewLogs && breadCrumbTabs.length ? <Box Box className="all-logs-breadcrumb-container">
                        <CustomTabs value={tab} onChange={handleChangeTab}
                            textColor="primary">
                            <CustomTab className="all-logs-breadcrumb-item" value={"Root"} label={"Root"} onClick={() => handleSelectTab("root", -1)} />
                            {breadCrumbTabs.map((item, index) => {
                                if (tabWidthOverFlow && index < breadCrumbTabs.length - 4) {
                                    return
                                }
                                if (tabWidthOverFlow && index === breadCrumbTabs.length - 4) {
                                    return <CustomTab className="all-logs-breadcrumb-tab" onClick={handleOpenOtherTabs} value={"..."} label={"..."} />
                                }
                                if (tabWidthOverFlow && index > breadCrumbTabs.length - 4) {
                                    return <CustomTab className="all-logs-breadcrumb-item all-logs-breadcrumb-tab" value={item.id} label={item.name} onClick={() => handleSelectTab(item, index)} />
                                }
                                return <CustomTab className="all-logs-breadcrumb-item all-logs-breadcrumb-tab" value={item.id} label={item.name} onClick={() => handleSelectTab(item, index)} />
                            })}

                        </CustomTabs>
                    </Box> : ""}

                    {searchedLogs?.length ?
                        <div className="logs-search-finded-container">
                            <Button className='logs-search-finded-button logs-search-finded-button-icon'
                                onClick={() => handleMoveHighlight("first")}
                                disabled={searchedLogIndex === 1}
                                style={{ opacity: `${searchedLogIndex > 1 ? "1" : "0.5"}`, padding: "3px 4px" }}
                                color={searchedLogIndex === 1 ? '#46474E' : 'default'} >
                                <FirstPageIcon style={{ width: "13px", height: "17px", color: "#BFBFBF" }} />
                            </Button>
                            <Button className='logs-search-finded-button logs-search-finded-button-icon'
                                onClick={() => handleMoveHighlight("left")}
                                disabled={searchedLogIndex === 1}
                                style={{ opacity: `${searchedLogIndex > 1 ? "1" : "0.5"}` }}
                                color={searchedLogIndex === 1 ? '#46474E' : 'default'} >
                                <img src={leftIcon} />
                            </Button>
                            {/* <p className="logs-search-finded-text"> <span className="logs-search-finded-count">"{findCount}"</span>{t(label + "FIND-COUNT")}</p> */}
                            {/* <p className="logs-search-finded-text"> <span className="logs-search-finded-count">"{resultRefs?.current && resultRefs.current.length ? highlightedIndex + 1 : 0}/{findCount}"</span>{t(label + "FIND-COUNT")}</p> */}
                            <p className="logs-search-finded-text"> <span className="logs-search-finded-count">"{searchedLogIndex}/{searchedLogs.length}"</span>{t(label + "FIND-COUNT")}</p>
                            <Button className='logs-search-finded-button logs-search-finded-button-icon'
                                onClick={() => handleMoveHighlight("right")}
                                disabled={searchedLogIndex === searchedLogs.length}
                                style={{ opacity: `${searchedLogIndex < searchedLogs.length ? "1" : "0.5"}` }}
                                color={searchedLogIndex === searchedLogs.length ? '#46474E' : 'default'} >
                                <img src={rightIcon} />
                            </Button>
                            <Button className='logs-search-finded-button logs-search-finded-button-icon'
                                onClick={() => handleMoveHighlight("last")}
                                disabled={searchedLogIndex === searchedLogs.length}
                                style={{ opacity: `${searchedLogIndex < searchedLogs.length ? "1" : "0.5"}`, padding: "3px 4px" }}
                                color={searchedLogIndex === searchedLogs.length ? '#46474E' : 'default'} >
                                <LastPageIcon style={{ width: "13px", height: "17px", color: "#BFBFBF" }} />
                            </Button>
                        </div>
                        : ""}
                </DialogContent>
                <DialogContent className="log-detail-container all-log-detail-container" style={{ height: selectedGroupLog?.group_id ? "72%" : "78%" }}>
                    {loading && !selectedGroupLog.group_id ? <div className='db-create-loading-page'><CircularProgress /></div>
                        : logs.length ?
                            isNewLogs && selectedGroupLog.group_id
                                ? <div className={`log-row-container bigger-row all-log-groupable-container`}>
                                    <>
                                        <LogsDetail log={selectedGroupLog} index={0} searchTerm={searchTerm}
                                            img={
                                                (!selectedGroupLog.image && selectedGroupLog.level === "TRIGGER-PARAM")
                                                    ? LogWebhookIcon
                                                    : (!selectedGroupLog.image && selectedGroupLog.level === "WARNING")
                                                        ? LogWarningIcon
                                                        : selectedGroupLog.image?.includes('data:') ? selectedGroupLog.image :
                                                            `${base_origin}/libraries/${!selectedGroupLog.image || selectedGroupLog.is_system ? "system" : "custom"}/${selectedGroupLog.image ? selectedGroupLog.image : defaultLibraryImg}`
                                            }
                                            isSelectedGroupLog={true}
                                            logTag={selectedGroupLog.tag === "autom_started" ? "Autom started" :
                                                selectedGroupLog.tag === "autom_ended" ? "Autom ended" : ""}
                                            info={selectedGroupLog.tag === "autom_started" || selectedGroupLog.tag === "autom_ended" ? selectedGroupLog?.info :
                                                ""}
                                            handleOpenInfoArea={handleOpenInfoArea}
                                            findedOpetaionGroupIds={findedOpetaionGroupIds}
                                            handleSelectGroupLog={handleSelectGroupLog}
                                            setLogs={setLogs}
                                            isHighlight={searchedLogs.length ? selectedGroupLog.group_id === searchedLogs[searchedLogIndex - 1]?.group_id : summaryLog ? summaryLog.groupId === selectedGroupLog.group_id : false}
                                            setOpenEhLogs={setOpenEhLogs} />
                                        <div className="all-logs-groupable-items-container">
                                            {loading ? <div className='db-create-loading-page'><CircularProgress /></div>
                                                : logs.map((log, index) => {
                                                    const names = log.defination?.split('_')
                                                    return <LogsDetail log={log} index={((currentIndex - 1) * itemsPerPage) + index} names={names} searchTerm={searchTerm}
                                                        img={
                                                            (!log.image && log.level === "TRIGGER-PARAM")
                                                                ? LogWebhookIcon
                                                                : (!log.image && log.level === "WARNING")
                                                                    ? LogWarningIcon
                                                                    : log.image?.includes('data:') ? log.image :
                                                                        `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                                        }
                                                        logTag={log.tag === "autom_started" ? "Autom started" :
                                                            log.tag === "autom_ended" ? "Autom ended" : ""}
                                                        info={log.tag === "autom_started" || log.tag === "autom_ended" ? log?.info :
                                                            ""}
                                                        handleOpenInfoArea={handleOpenInfoArea}
                                                        findedOpetaionGroupIds={findedOpetaionGroupIds}
                                                        handleSelectGroupLog={handleSelectGroupLog}
                                                        setLogs={setLogs}
                                                        isHighlight={searchedLogs.length ? log.group_id === searchedLogs[searchedLogIndex - 1]?.group_id : summaryLog ? summaryLog.groupId === log.group_id : false}
                                                        setOpenEhLogs={setOpenEhLogs}
                                                    />
                                                })}
                                        </div>
                                    </>
                                    <Pagination totalItems={logsCount} callFetch={groupFetchData} outPage={outPage} outItemsPerPage={() => {
                                        if (outItemsPerPage) {
                                            return outItemsPerPage
                                        }
                                        return getLocalItemsForPagination("logs")
                                    }} />
                                </div>
                                : isNewLogs
                                    ? logs.map((log, index) => {
                                        const names = log.defination?.split('_')
                                        return <LogsDetail log={log} index={(((currentIndex - 1) * itemsPerPage) + index) - 1} names={names} searchTerm={searchTerm}
                                            img={
                                                (!log.image && log.level === "TRIGGER-PARAM")
                                                    ? LogWebhookIcon
                                                    : (!log.image && log.level === "WARNING")
                                                        ? LogWarningIcon
                                                        : log.image?.includes('data:') ? log.image :
                                                            `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                            }
                                            logTag={log.tag === "autom_started" ? "Autom started" :
                                                log.tag === "autom_ended" ? "Autom ended" : ""}
                                            info={log.tag === "autom_started" || log.tag === "autom_ended" ? log?.info :
                                                ""}
                                            handleOpenInfoArea={handleOpenInfoArea}
                                            findedOpetaionGroupIds={findedOpetaionGroupIds}
                                            handleSelectGroupLog={handleSelectGroupLog}
                                            setLogs={setLogs}
                                            isHighlight={searchedLogs.length ? log.group_id === searchedLogs[searchedLogIndex - 1]?.group_id : summaryLog ? summaryLog.groupId === log.group_id : false}
                                            setOpenEhLogs={setOpenEhLogs}
                                        />
                                    })
                                    : logs.map((log, index) => {
                                        const names = log.defination?.split('_')
                                        return isMidLogs
                                            ? <MidLogsDetail log={log} index={((currentIndex - 1) * itemsPerPage) + index} names={names} highlightText={highlightText} searchTerm={searchTerm}
                                                img={log.image?.includes('data:') ? log.image :
                                                    `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                                }
                                                data={data}
                                                logType={log.tag === "autom_started" ? "Autom started" :
                                                    log.tag === "autom_ended" ? "Autom ended" : ""}
                                                findedOpetaionGroupIds={findedOpetaionGroupIds}
                                            />
                                            : <OldLogsDetail log={log} index={((currentIndex - 1) * itemsPerPage) + index} names={names}
                                                img={log.image?.includes('data:') ? log.image :
                                                    `${base_origin}/libraries/${!log.image || log.is_system ? "system" : "custom"}/${log.image ? log.image : defaultLibraryImg}`
                                                }
                                                logType={log.text === "Flow started working" ? "Autom started" : log.text === "DebugFlow started working" ? "Debug Autom started" :
                                                    log.text === "Flow completed successfully" ? "Autom ended" : ""}
                                            />
                                    }) :
                            <div className='empty-page-info-container'>
                                <img src={emptyPageIcon} />
                                <p className='info-text'>{t(label + 'EMPTY-LOGS')}</p>
                            </div>
                    }
                </DialogContent >
                {!selectedGroupLog?.group_id
                    ? <Pagination totalItems={logsCount} callFetch={fetchData} outPage={outPage} outItemsPerPage={() => {
                        if (outItemsPerPage) {
                            return outItemsPerPage
                        }
                        return getLocalItemsForPagination("logs")
                    }} /> : ""}
            </div >
            {
                selectedLog.level && isNewLogs
                    //setSelectedLog, findLogIcon, setFullScreenValue, setOpenEhLogs, setType, showPreviewData, handleCopyInputAndOutput
                    ? <LogInfoDetails selectedLog={selectedLog} setSelectedLog={setSelectedLog} findLogIcon={findLogIcon} setFullScreenValue={setFullScreenValue}
                        setOpenEhLogs={setOpenEhLogs} setType={setType}
                        label={label} type={type} data={data} /> : ""
            }
            {
                otherTabs.length ?
                    <Dialog
                        id="all-operation-log-dialog"
                        data-test="autom-add-new"
                        className="autom-group"
                        open={true}
                        onClose={() => {
                            setOtherTabs([])
                            setSearchOtherTabs([])
                        }}
                        PaperProps={{
                            style: {
                                // minWidth: "95%",
                                width: "40%",
                                // height: "90%",
                                height: "60%",
                                borderRadius: " 4px",
                                // padding: "4px 22px",
                                padding: "0",
                                flexDirection: "column",
                                gap: "10px",
                                overflow: "hidden"
                            },
                        }}
                    >
                        <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 0, textAlign: "end" }}>
                            <Close className="autom-group-close-button logs-close-icon" onClick={() => {
                                setOtherTabs([])
                                setSearchOtherTabs([])
                            }} style={{ fontSize: "1rem" }} />
                        </DialogTitle>
                        <DialogContent className="all-logs-search-container all-logs-other-breadcrumb-search-container">
                            {isNewLogs ? <Search data={otherTabs} setSearchData={setSearchOtherTabs} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                                searchKey={['name']} /> : ""}
                        </DialogContent>

                        <DialogContent className="all-logs-other-breadcrumb-container">
                            <p className="all-logs-other-breadcrumb-title">{t(label + "NAVIGATION")}</p>
                            {searchOtherTabs.map((tab, index) => {
                                return <div className="all-logs-other-breadcrumb-item-container" onClick={() => {
                                    setTabWidthOverFlow(false)
                                    handleSelectTab(tab, index)
                                    setTab(tab.id)
                                    setOtherTabs([])
                                }}>
                                    <span className="all-logs-other-breadcrumb-count">{index + 1}.</span>
                                    <img className="all-logs-details-header-action-image" src={tab.image?.includes('data:') ? tab.image :
                                        `${base_origin}/libraries/${!tab.image || tab.is_system ? "system" : "custom"}/${tab.image ? tab.image : defaultLibraryImg}`
                                    } />
                                    <span className="all-logs-other-breadcrumb-text">{tab.name}</span>
                                </div>
                            })}
                        </DialogContent>
                    </Dialog>
                    : ""
            }

            {
                fullScreenValue.type ? <FullScreen title={fullScreenValue.type === "object" ? t(label + `PREVIEW`) : fullScreenValue.type}
                    handleClose={() => setFullScreenValue({ type: "", value: "" })} type={fullScreenValue.type ? fullScreenValue.type : "object"}
                    item={fullScreenValue} label={label}>
                    {type === "input"
                        ? <div className={`preview-data-content full-height`}>
                            {/* <ObjectInspector data={fullScreenValue.value ? fullScreenValue.value : {}} theme={customTheme} /> */}
                            {showPreviewData(fullScreenValue.value, fullScreenValue.type ? fullScreenValue.type : "object", fullScreenValue.cantParse, "fullScreen")}
                        </div>
                        : <div className={`preview-data-content full-height ${fullScreenValue.type === "data table" ? "preview-data-content-data-table" : ""}`}>
                            {/* {fullScreenValue.value} */}
                            {showPreviewData(fullScreenValue.value, fullScreenValue.type, fullScreenValue.cantParse, "fullScreen")}
                        </div>}
                </FullScreen> : ""
            }
            {openEhLogs ? <AllOperationLogs data={data} setOpenActivityLog={() => setOpenEhLogs(false)} setSelectedOperation={setSelectedOperation} ehLog={true} ehGroupId={openEhLogs} /> : ""}
        </Dialog >
    )
}
